/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_4_VInputs */

const en_mk_aicost_4_v = /** @type {(inputs: Mk_Aicost_4_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 tasks + 20/seat`)
};

const id_mk_aicost_4_v = /** @type {(inputs: Mk_Aicost_4_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 tugas + 20/kursi`)
};

/**
* | output |
* | --- |
* | "300 tasks + 20/seat" |
*
* @param {Mk_Aicost_4_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_4_v = /** @type {((inputs?: Mk_Aicost_4_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_4_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_4_v(inputs)
	return en_mk_aicost_4_v(inputs)
});